import React from "react";
import CheckCircle from "../../../../components/Icons/CheckCirle";

const ReviewSubmitSuccess = () => {

    return <div>
        <main className="sl-main sl-mt-8">
            <div className="sl-container sl-m-auto sl-my-8 sl-bg-white sl-shadow-sm sl-border-radius-8
                sl-pt-8 sl-pl-40 sl-pr-40 sl-pb-8  sl-display-flex sl-flex-col sl-max-w-252
                ">
                <div className="sl-display-flex  sl-flex-col sl-justify-center">
                    <div
                        className="sl-h-fit-content sl-w-fit-content sl-m-auto">
                        <CheckCircle/>
                    </div>
                    <span
                        className="sl-text-gray-900 sl-text-xxl sl-font-semibold sl-pb-2 sl-pt-6">Review submitted</span>
                    <span className="sl-text-gray-700 sl-text-sm sl-pb-8">Thank you for submitting your review.</span>

                    <div
                        className="sl-flex sl-justify-center sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                        <button
                            onClick={() => window.location.href = "https://myshortlister.com"}
                            className="sl-btn sl-btn-primary sl-btn-lg  sl-rounded-lg sl-text-sm sl-h-12">
                            Go to Home page
                        </button>
                    </div>
                </div>
            </div>
        </main>
    </div>
}

export default ReviewSubmitSuccess;